import React from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  deleteTicket,
  getTicketsList,
  replayTicket,
} from "../../../redux/ticket/slice";
import { Badge } from "../../../components/micro";
import Action from "../../../commons/Action";
import { User } from "../../../assets/svg/AllSvg";

const AllTickets = ({
  setReplyTicketModel,
  element,
  setTicketData,
  searchValue,
  selectedPriority,
  selectedPeriod,
  pageCount,
  pageLimit,
  listStatus,
}) => {
  const dispatch = useDispatch();

  const updateTickets = ({ id, payload }) => {
    dispatch(replayTicket({ id: id, data: payload })).then((res) => {
      if (res.type === "replayTicket/fulfilled") {
        dispatch(
          getTicketsList({
            search: searchValue,
            priority: selectedPriority?.value ?? "",
            period: selectedPeriod?.value ?? "",
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: listStatus,
          })
        );
      }
    });
  };
  // Delete Ticket
  const handleDelete = (id) => {
    dispatch(deleteTicket(id)).then((res) => {
      if (res.type === "deleteTicket/fulfilled") {
        dispatch(
          getTicketsList({
            search: searchValue,
            priority: selectedPriority?.value ?? "",
            period: selectedPeriod?.value ?? "",
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: listStatus,
          })
        );
      }
    });
  };

  return (
    <div className="hover:card border !rounded-lg space-y-4 p-4 hover:bg-light_secondary_shades">
      <div className="sm:flex justify-between items-center sm:space-y-0 space-y-1">
        <div className="flex sm:flex-nowrap flex-wrap items-center sm:justify-normal justify-between space-x-2 sm:space-y-0 space-y-1.5">
          <span
            className={`${
              element?.status === "new"
                ? "bg-light_primary_50p text-white"
                : element?.status === "on_going"
                ? "bg-primary_shades_light text-theme"
                : element?.status === "resolved"
                ? "bg-light_secondary_green text-theme"
                : "bg-light_action_disabled text-theme"
            } rounded-t-md lg:px-4 sm:px-3 px-2 lg:text-base sm:text-sm text-xs py-1`}
          >
            {element?.status === "new"
              ? "New"
              : element?.status === "on_going"
              ? "On Going"
              : element?.status === "resolved"
              ? "Resolved"
              : "Archived"}
          </span>
          <p className="text-secondary lg:text-base sm:text-sm text-xs">
            Ticket# {element?.unique_id}
          </p>
          <Badge
            value={
              element?.priority === "mid"
                ? "Mid Priority"
                : element?.priority === "low"
                ? "Low Priority"
                : "High Priority"
            }
            className={`border ${
              element?.priority === "mid"
                ? "bg-secondary_color border-secondary_color"
                : element?.priority === "low"
                ? "bg-warning_color border-warning_color"
                : "bg-danger_color border-danger_color"
            } text-white text-xs !px-2 !py-0.5`}
          />
        </div>
        <div className="flex items-center sm:justify-normal justify-between space-x-2">
          <p className="text-light_grey lg:text-base sm:text-sm text-xs">
            Last Updated on{" "}
            {moment(element?.updated_at).format("DD/MM/YYYY | HH:MM")}
          </p>
          <Action
            optionList={
              <>
                <li
                  className="flex gap-2 items-center lg:px-6 sm:px-5 px-4 lg:py-2 py-1 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                  onClick={() => {
                    const payload = {
                      status:
                        element?.status === "archived"
                          ? "on_going"
                          : "archived",
                    };
                    updateTickets({ id: element?.id, payload: payload });
                  }}
                >
                  {element?.status === "archived" ? "Unarchive" : "Archive"}
                </li>
                {element?.status === "archived" && (
                  <li
                    className="flex gap-2 items-center lg:px-6 sm:px-5 px-4 lg:py-2 py-1 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                    onClick={() => {
                      handleDelete(element?.id);
                    }}
                  >
                    Delete
                  </li>
                )}
                {element?.status === "resolved" && (
                  <li
                    className="flex gap-2 items-center lg:px-6 sm:px-5 px-4 lg:py-2 py-1 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                    onClick={() => {
                      const payload = {
                        status: "on_going",
                      };
                      updateTickets({ id: element?.id, payload: payload });
                    }}
                  >
                    Reopen
                  </li>
                )}
              </>
            }
          />
        </div>
      </div>
      <div className="space-y-1">
        <p className="text-secondary lg:text-base sm:text-sm text-xs">
          {element?.title}
        </p>
        <div
          className="text-light_grey max-w-full truncate lg:text-base sm:text-sm text-xs"
          dangerouslySetInnerHTML={{ __html: element?.message }}
        />
      </div>
      <div className="flex items-center justify-between">
        {element?.staff ? (
          <div className="flex gap-3 items-center max-w-xs sm:w-full lg:text-base sm:text-sm text-xs">
            <div className="lg:max-w-8 max-w-5 w-full lg:h-8 h-5 flex justify-center items-center bg-grey rounded-full">
              {element?.staff?.profile_path ? (
                <img
                  src={element?.staff?.profile_path}
                  alt="profile"
                  className="w-full h-full object-cover"
                />
              ) : (
                <User pathClass="fill-white" fillOpacity={1} />
              )}
            </div>
            {element?.staff?.full_name}
          </div>
        ) : (
          <div></div>
        )}
        <button
          className="text-theme border-b border-theme lg:text-base sm:text-sm text-xs"
          onClick={() => {
            setTicketData(element);
            setReplyTicketModel(true);
          }}
        >
          Open Ticket
        </button>
      </div>
    </div>
  );
};

export default AllTickets;
